<template>
  <div class="Logo">  
    <div class="Logo__container" v-if="ready">


      <div class="Logo__container-lines" :class="tint">

      <svg width="130.005" height="143.531" viewBox="0 0 130 143">
        <g transform="translate(-446.562 -442.071)">
          <path id="twelve" d="M491.2,486.515h55.526" transform="translate(-0.631 7)" fill="none" stroke="#fff" stroke-width="10"/> 
          <path id="last" d="M491.2,486.515h15.446" transform="translate(59.369 7)" fill="none" stroke="#fff" stroke-width="10"/> 
          <path id="eight" d="M506.9,515.126l65.267.06s.035,9.308.035,17.811c0,3.645-.069,7.345-.069,9.6" transform="translate(-0.641 2.016)" fill="none" stroke="#fff" stroke-width="10"/>
          <path id="nine" d="M521.255,548.589l50.839.034.1-13.147" transform="translate(-0.631 1)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="10"/>
          <path id="one" d="M541.643,504.878s-.245-17.665,0-26.974-10.255-10.394-10.255-10.394H482.013V444.529H529.63s14.037-.9,13.723,11.194-15.223,11.787-15.223,11.787" transform="translate(0.286 2.576)" fill="none" stroke="#fff" stroke-width="10"/>
          <path id="six" d="M541.722,524.525v27.858" transform="translate(0 33.218)" fill="none" stroke="#fff" stroke-width="10"/>
          <path id="five" d="M305.68,621.163c0,.007,0,13.269,0,13.254a15.98,15.98,0,0,0,1.857,7.1c2.549,4.933,11.948,14.364,21.048,15.533.705.137,10.917,0,10.917,0" transform="translate(206.292 -76.518)" fill="none" stroke="#fff" stroke-width="10"/> 
          <path id="four" d="M339.762,634.417a15.98,15.98,0,0,1-1.857,7.1c-2.549,4.933-11.948,14.364-21.048,15.533-.705.137-11.893,0-11.893,0" transform="translate(172.307 -76.518)" fill="none" stroke="#fff" stroke-width="10"/> 
          <path id="seven" d="M541.722,526.693v20.419" fill="none" stroke="#fff" stroke-width="10"/>  
          <path id="ten" d="M512.069,526.693v23.338H491.2" fill="none" stroke="#fff" stroke-width="10"/> 
          <path id="three" d="M482.3,526.693v54.93" fill="none" stroke="#fff" stroke-width="10"/> 
          <path id="two" d="M482.3,521.822V473.7" fill="none" stroke="#fff" stroke-width="10"/> 
          <path id="eleven" d="M481.33,493.515H451.562V549.5H481.33" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="10"/>
        </g>
      </svg>

    </div>

      <svg id="rwg-txt" viewBox="0 0 67 67">
        <g>
          <text id="rwg-one" class="cls-6" transform="translate(0 14.45) scale(1.06 1)">
            <tspan class="cls-12" x="0" y="0">R</tspan>
            <tspan class="cls-4" x="12.34" y="0">U</tspan>
            <tspan class="cls-7" x="25.74" y="0">G</tspan>
            <tspan class="cls-8" x="37.57" y="0">B</tspan>
            <tspan class="cls-2" x="49.67" y="0">Y</tspan>
          </text>
          <text id="rwg-two" class="cls-6" transform="translate(2.77 31.45) scale(.92 1)">
            <tspan class="cls-10" x="0" y="0">W</tspan>
            <tspan class="cls-11" x="17.7" y="0">O</tspan>
            <tspan class="cls-3" x="29.29" y="0">RLD</tspan>
          </text>
          <text id="rwg-tree" class="cls-5" transform="translate(14.16 44.45) scale(1 .9)">
            <tspan class="cls-9" x="0" y="0">G</tspan>
            <tspan class="cls-1" x="8.05" y="0">AME</tspan>
          </text>
        </g>
      </svg>
  
    </div>
  </div>
</template>

<script>

import gsap from "gsap"
import DrawSVGPlugin from "gsap/DrawSVGPlugin"
gsap.registerPlugin(DrawSVGPlugin)

export default {

  name: 'Logo',
  data:()=>({
    ready: false,
  }),
  computed: {
    initialized() { return this.$store.getters['commons/initialized'] },
    tint() { return this.$store.getters['commons/tint'] }
  },
  mounted() {
    this.ready = true
    this.$nextTick(()=>{
      // gsap.set(this.$el, { height: window.innerHeight })
      if(!this.initialized)
        gsap.delayedCall(1, ()=>this.draw())
      else 
        this.animate()

    })
  },
  methods:{

    getArrow() {

      if(!this.$root.isPhone) 
        return gsap.timeline({ })
                .from(['.App-arrow'], { duration: .35, y: '+=100', ease: 'cubic.out', opacity: 0 }, '-=.4')

    },

    getLineout() {
      return 

    },

    animate() {
      this.$tml = gsap.timeline({ delay: .35 })
          .from(['.Logo__container', '#rwg-one', '#rwg-two', '#rwg-tree'], { 
            duration: .35, 
            y: '+=25', 
            ease: 'cubic.out', 
            stagger: .2, 
            opacity: 0 
          })
          // .add([ this.getLineout() ])
    },

    draw() {
      const speed = .75
      this.$tml = gsap.timeline({  })
          // .set('.Logo', { opacity: 1 })
          .from('#three',{ ease: 'none', drawSVG:0 , duration: speed*.1 })
          .fromTo('#four',{ ease: 'none', drawSVG:"100% 100%"},{ drawSVG:"0% 100% ", duration: speed*.2 })
          .from('#five',{ ease: 'none', drawSVG:0 , duration: speed*.1 })
          .fromTo('#six',{ ease: 'none', drawSVG:"100% 100%"},{ drawSVG:"0% 100% ", duration: speed*.1 })
          .fromTo('#seven',{ ease: 'none', drawSVG:"100% 100%"},{ drawSVG:"0% 100% ", duration: speed*.1 })
          .from('#eight',{ ease: 'none', drawSVG:0 , duration: speed*.2 })
          .fromTo('#nine',{ ease: 'none', drawSVG:"100% 100%"},{ drawSVG:"0% 100% ", duration: speed*.1 })

          .from('#one',{ ease: 'none', drawSVG:0 , duration: speed*.25 })
          .fromTo('#two',{ ease: 'none', drawSVG:"100% 100%"},{ drawSVG:"0% 100% ", duration: speed*.1 })
          .from('#ten',{ ease: 'none', drawSVG:0 , duration: speed*.1 })
          .fromTo('#eleven',{ ease: 'none', drawSVG:"100% 100%"},{ drawSVG:"0% 100% ", duration: speed*.15 })
          .from('#twelve',{ ease: 'none', drawSVG:0 , duration: speed*.1 })
          .from('#last',{ ease: 'back.out', drawSVG:0 , duration: speed*.35, x: 10 })
          .from(['#rwg-one', '#rwg-two', '#rwg-tree'], { duration: .5, y: '+=25', ease: 'cubic.out', stagger: .2, opacity: 0 })
          .add([ this.getLineout() ])
    },
  }
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Logo
  position relative
  margin-top 80px

  &__container
    display flex
    flex-direction column
    align-items center

    &-lines 
      background black
      border-radius 50%
      width 30vh
      height 30vh
      margin 16px
      display flex
      align-items center
      justify-content center

      &.black
        background #000

      &.orange
        background #BC4D12

      &.green
        background #497c0c

      &.blue
        background #3351B9

      &.dark 
        background #1F1F1F

      &.purple
        background #8A1B79      
 
  & svg
    max-width 180px
    width 54%
    height auto 
    fill white

  & #rwg-txt
    padding-top 0%

  .cls-1
    letter-spacing .03em
  .cls-2
    letter-spacing .03em
  .cls-3
    letter-spacing .03em
  .cls-4
    letter-spacing .03em
  .cls-5
    font-family factoria
    font-weight 400
    font-size 12px
  .cls-5,.cls-6
    fill #231f20
  .cls-7
    letter-spacing .03em
  .cls-8
    letter-spacing .02em
  .cls-9
    letter-spacing .01em
  .cls-10
    letter-spacing 0em
  .cls-11
    letter-spacing .01em
  .cls-12
    letter-spacing .01em
  .cls-6
    font-family factoria
    font-weight 900
    font-size 17px

</style>


